import React from 'react'
import Navigation from '../nav/Navigation'
import MobileNav from '../nav/mobile/MobileNav'
import Logo from '../Logo/Logo'
import { SecondaryLinks } from '../nav/SecondaryLinks'
import { useMenuQuery } from '../../hooks/useMenuQuery'
import { Link } from '../global'

import './header.scss'

const Header = ({
  setIsAccordionOpen,
  isAkutrutaActive,
  setIsSubMenuActive,
  logoSrc,
  homePath,
  pageContext,
}) => {
  const { menu, secondaryMenu } = useMenuQuery()

  const linkTo = homePath || '/'

  return (
    <>
      <div className="header fullWidthContainer">
        <div className="innerContainer">
          <div className="header-row">
            <Link to={linkTo} style={{ fontSize: 0 }}>
              <Logo src={logoSrc} height="38px" />
            </Link>
            <Navigation
              menu={menu}
              secondaryMenu={secondaryMenu}
              isAkutrutaActive={isAkutrutaActive}
              logoSrc={logoSrc}
              pageContext={pageContext}
              
            />
          </div>
        </div>
      </div>
      <SecondaryLinks menu={menu} setIsSubMenuActive={setIsSubMenuActive} />
      <MobileNav
        setIsAccordionOpen={setIsAccordionOpen}
        menu={menu}
        secondaryMenu={secondaryMenu}
        logoSrc={logoSrc}
        homePath={homePath}
        pageContext={pageContext}
      />
    </>
  )
}

export default Header
